/* .ctaContainer {
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
} */

.ctaParent {
  border-width: 0.74px;
  border-radius: 12px;
  width: 585px;
  height: 64px;
  margin: 8px auto 32px auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: var(--text-color-6);
  background: #121212;
  border: 1px solid var(--secondary-color);
  position: relative;
}

.ctaParent::before {
  content: "";
  background: url(../../assets/images/CTA-bg.jpg) center/cover no-repeat;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 12px;
}

.ctaParent.small {
  width: 400px;
  margin: 0;
}

.ctaParent.small .reward {
  padding: 0 12px;
}

.contactParent {
  font-family: "Inter", sans-serif;
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  display: flex;
  align-items: center;
  flex: 1;
  position: relative;
  margin-left: 22px;
}

.contactWrapper {
  display: flex;
  align-items: center;
  flex: 1;
  position: relative;
}

.contactWrapper::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  height: 80%;
  width: 2px;
  background-color: var(--text-color-3);
  margin-left: 16px;
}

.countryCode {
  font-weight: 400;
  font-size: 20px;
  line-height: 24px;
  letter-spacing: 0px;
  vertical-align: middle;
}

.contactInput {
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  font-weight: 400;
  font-size: 20px;
  line-height: 24px;
  letter-spacing: 0px;
  padding: 12px 22px 12px 32px;
  color: var(--text-color-1);
  vertical-align: middle;
}

.reward {
  display: flex;
  gap: 2px;
  align-items: center;
  white-space: nowrap;
  margin-right: 22px;
  font-weight: 400;
  cursor: pointer;
  font-size: 14px;
  line-height: 24px;
  color: var(--text-color-1);
  height: 36px;
  position: relative;
  z-index: 1;
  border: 1px solid #ffffff44;
  border-radius: 8px;
  backdrop-filter: blur(4px);
  background: linear-gradient(296deg, #d2a54b47 20.35%, #247a8d00 68.41%);
  padding: 0 16px;
  box-shadow: 25px 5px 25px -12px #bfa161;
}

.rewardSvg {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 0px;
  height: 20px;
}

.reward svg {
  height: 16px;
  margin-left: 10px;
  fill: var(--primary-color);
}

.disabledReward {
  cursor: not-allowed;
}

.errorMessage {
  color: red;
  font-size: 14px;
  text-align: center;
  margin-top: 8px;
}

.loader {
  width: 12px;
  height: 12px;
  border: 3px solid rgba(255, 255, 255, 0.3);
  border-top-color: white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  display: inline-block;
  margin-left: 2px;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.successAnim,
.errorAnim {
  height: 26px;
  vertical-align: bottom;
}

.tooltip {
  position: fixed;
  background: rgba(50, 50, 50, 0.9);
  color: white;
  padding: 5px 10px;
  border-radius: 5px;
  font-size: 12px;
  white-space: nowrap;
  pointer-events: none;
  transform: translate(-50%, -50%);
}

.ctaParentDownload {
  all: unset;
  z-index: 1;
  opacity: 1;
  color: var(--text-color-1);
  font-size: 16.43px;
  font-weight: 400;
  line-height: 27.38px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  gap: 24px;
}

.modalOverlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1001;
}

.fadeIn {
  animation: fadeIn 0.3s ease-in-out;
}

.fadeOut {
  animation: fadeOut 0.3s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes fadeOut {
  from {
    opacity: 1;
    transform: scale(1);
  }
  to {
    opacity: 0;
    transform: scale(0.9);
  }
}

.modalContent {
  position: relative;
  width: 100%;
  height: 100%;
  background: var(--background-color);
}

.closeButton {
  position: absolute;
  top: 20px;
  right: 20px;
  background: transparent;
  border: none;
  color: white;
  font-size: 24px;
  cursor: pointer;
}

.modalContentMain {
  position: relative;
  margin-top: 100px;
}

.modalHeadingParent {
  width: 250;
  letter-spacing: 1.5px;
  display: inline-block;
}

.modalHeading {
  font-family: Denton Test, sans-serif;
  font-size: 24px;
  font-weight: 400;
  color: var(--text-color-1);
  line-height: 100%;
  text-align: center;
  vertical-align: middle;
  margin: 0;
}

.modalBg {
  width: 85%;
  margin-top: 20px;
  margin-bottom: 48px;
}

.modalInputWrapper {
  position: relative;
  z-index: 10;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.modalInput {
  font-size: 18px;
  padding: 10px;
  width: 80%;
  border: 1px solid #ccc;
  border-radius: 5px;
  text-align: center;
}

.large .disabledReward {
  opacity: 0.5;
}

@media (max-width: 990px) {
  .ctaParent.small {
    width: 500px;
  }
}

@media (max-width: 720px) {
  .ctaParent.large {
    margin-left: auto;
    margin-right: auto;
    width: 85%;
  }
  .ctaParent.small {
    width: 100%;
    margin-top: 16px;
    margin-bottom: 12px;
  }
  .ctaParent {
    margin-left: unset;
    margin-right: unset;
    margin-bottom: 26px;
  }
  .large .disabledReward {
    display: flex;
    justify-content: center;
  }
  .free {
    display: none;
  }
}

@media (max-width: 600px) {
  .ctaParent {
    height: 60px;
  }
  .large .contactParent {
    margin-left: 16px;
  }
  .countryCode {
    font-weight: 300;
    font-size: 16px;
  }
  .contactWrapper:before {
    height: 70%;
    margin-left: 11px;
  }
  .contactInput {
    padding: 12px 8px 12px 22px;
    width: 100%;
    font-weight: 300;
    font-size: 16px;
  }
  .reward {
    margin-right: 16px;
    padding: 0 10px;
  }
  .small .contactInput {
    width: 100%;
  }
}

@media (max-width: 480px) {
  .reward {
    margin-right: 12px;
  }
  .contactParent {
    margin-left: 12px;
  }
  .contactWrapper:before {
    margin-left: 12px;
  }
  .contactInput {
    padding: 12px 12px 12px 24px;
  }
}

@media (max-width: 400px) {
  .ctaParent.large {
    width: 95%;
  }
  .large .contactParent {
    margin-left: 6px;
  }
  .contactInput {
    padding: 12px 6px 12px 12px;
  }
  .contactParent,
  .contactWrapper:before {
    margin-left: 4px;
  }
  .reward {
    margin-right: 6px;
    padding: 0 6px;
  }
  .modalContentMain {
    margin-top: 60px;
    position: relative;
  }
  .modalBg {
    width: 85%;
    margin-top: 12px;
    margin-bottom: 20px;
  }
  .closeButton {
    top: 12px;
    right: 12px;
  }
}
